import { render, staticRenderFns } from "./eventsReadOnly.vue?vue&type=template&id=4d5426d8&class=app-bg-login&"
import script from "./eventsReadOnly.vue?vue&type=script&lang=ts&"
export * from "./eventsReadOnly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports